import { word } from "@/modules/core/utils/i18n"
import { TemplateCategoryDtoSchema } from "@/modules/template/gateway/templateCategoryDto"
import { MAX_255_CHARACTERS, MAX_64_CHARACTERS } from "@/typings/formik"
import { z } from "zod"

export const templateFormValidation = z.object({
  name: z
    .string()
    .min(1, word("global.form.required"))
    .max(MAX_64_CHARACTERS, word("form.maximum.characters", { count: MAX_64_CHARACTERS })),
  description: z
    .string()
    .max(MAX_255_CHARACTERS, word("form.maximum.characters", { count: MAX_255_CHARACTERS }))
    .nullable(),
  category: TemplateCategoryDtoSchema.nullable(),
})

export const TemplateWeekFormValidationSchema = templateFormValidation.extend({
  sessionIds: z.array(z.string()).min(1, word("global.form.required")),
})

export const TemplateSessionFormValidationSchema = templateFormValidation.extend({
  sessionId: z.string().min(1, word("global.form.required")),
})

export const TemplateExerciseFormValidationSchema = templateFormValidation.extend({
  exerciseId: z.string().min(1, word("global.form.required")),
})
